var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled from 'styled-components';
import { Spin, Dropdown } from 'antd';
import { Icon } from '../components/Icon';

var Widget = function Widget(_ref) {
  var height = _ref.height,
      children = _ref.children,
      style = _ref.style;
  return /*#__PURE__*/React.createElement(WidgetContainer, {
    height: height,
    style: style
  }, /*#__PURE__*/React.createElement(InnerContainer, null, children));
};

var Content = function Content(_ref2) {
  var loading = _ref2.loading,
      children = _ref2.children,
      style = _ref2.style;
  return /*#__PURE__*/React.createElement(WidgetContentContainer, null, /*#__PURE__*/React.createElement(WidgetContent, {
    style: style
  }, !loading && children, loading && /*#__PURE__*/React.createElement(Spinner, null, /*#__PURE__*/React.createElement(Spin, {
    size: "large"
  }))));
};

var MenuButton = function MenuButton(_ref3) {
  var menu = _ref3.menu,
      style = _ref3.style;
  return /*#__PURE__*/React.createElement(Dropdown, {
    overlay: menu,
    placement: "bottomRight",
    trigger: ['click']
  }, /*#__PURE__*/React.createElement(MenuButtonContainer, {
    style: style
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "ellipsis-v"
  })));
};

var WidgetContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  margin-bottom: 24px;\n  background-color: #fff;\n  /* position: relative; */\n  overflow: hidden;\n  border-radius: 4px;\n  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);\n"])), function (p) {
  return p.height + 'px';
});
var InnerContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100%;\n  color: #333;\n  overflow: hidden;\n"])));
var Header = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 40px;\n  line-height: 20px;\n  padding: 10px 10px 10px 15px;\n  background-color: #eceeef;\n  font-size: 16px;\n  box-sizing: border-box;\n  position: relative;\n  border-bottom: 1px solid #d0d3d6;\n  font-weight: bold;\n\n"])));
var WidgetContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 100%;\n  overflow-y: auto;\n"])));
var WidgetContentContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 100%;\n  padding-bottom: 40px;\n  overflow: hidden;  \n"])));
var Spinner = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n"])));
var MenuButtonContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\nposition: absolute;\nright: 10px;\ntop: 10px;\n  color: #666;\n  font-size: 16px;\n  font-weight: normal;\n  padding: 0 5px;\n  cursor: pointer;\n  &:hover {\n    color: #333;\n  }\n"])));
Widget.Header = Header;
Widget.Content = Content;
Widget.MenuButton = MenuButton;
export default Widget;